export const CHARGE_DATA_REQUEST = "chargeData/CHARGE_DATA_REQUEST";
export const CHARGE_DATA_SUCCESS = "chargeData/CHARGE_DATA_SUCCESS";
export const CHARGE_DATA_FAILED = "chargeData/CHARGE_DATA_FAILED";
export const CHANGE_PAGE = "chargeData/CHANGE_PAGE";
export const CHANGE_PER_PAGE = "chargeData/CHANGE_PER_PAGE";
export const CHANGE_FILTERS = "chargeData/CHANGE_FILTERS";
export const EMPTY_CHARGE_DATA = "chargeData/EMPTY_CHARGE_DATA";
export const RESET_FILTERS = "chargeData/RESET_FILTERS";